<template>
<div class="hg-hibox">
    <!-- <v-select   :options="values" 
                v-model="value" 
                @input="onChange($event)"
                class="hg-select"
                :searchable="false" 
                :filterable="false" 
                :clearable="false" 
                :reduce="t => t.Sku">
        <template slot="selected-option" slot-scope="option">
            <div class="hibox-item">
                <strong>{{option.Sku}}</strong>
                <span v-if="Array.isArray(option.entities)">
                    <small class="option-game_fields" v-for="e in option.entities" :key="e.id">
                        {{e.name}}
                    </small>
                </span>
            </div>
        </template>
        <template slot="option" slot-scope="option">
            <div class="hibox-item">
                <strong>{{option.Sku}}</strong>
                <span v-if="Array.isArray(option.entities)">
                    <small class="option-game_fields" v-for="e in option.entities" :key="e.id">
                        {{e.name}}
                    </small>
                </span>
            </div>
        </template>
    </v-select> -->
    <select class="hg-select" 
            v-model="value"
            :disabled="disabled"
            @change="onChange($event.target.value)"
            :readonly="schema.readonly">
        <option></option>
        <option v-for="opt in values" 
                :key="opt.Id" 
                :value="opt.Sku">
            {{opt.Sku}}
            {{(opt.entities && opt.entities.length>0)?(' - ' + opt.entities.map(x=>x.name).join(",")):('')}}
        </option>
    </select>
</div>
</template>
<style scoped>
.hibox-item{
    display:flex;
}
.hibox-item strong{
    width:150px;
    display:block;
    flex:0 0 auto;
}
/* .option-game_fields{
    background: #eee;
    padding:2px;
    border-radius:var(--border-radius);
    margin-top:-7px;
    height:30px;
}
.option-game_fields img{
    height:24px;
    border-radius:50%;
    vertical-align: middle;
} */
</style>
<script>
   import { abstractField } from "vue-form-generator";

   export default {
        mixins: [ abstractField ],
        mounted(){
            var self = this;
            if(Array.isArray(this.schema.values)){
                this.values = this.schema.values;
                this.bindGameFields();
            }else if(this.schema.values instanceof Promise){
                this.schema.values.then(function(response){
                    try{
                        if(Array.isArray(response)){
                            self.values = response;
                        }else if(Array.isArray(response.entries)){
                            self.values = response.entries;
                        }else{
                            console.error("NO ARRAY", response)
                        }
                        self.bindGameFields()
                    }catch(ex){
                        console.error(ex)
                    }
                })
            }

        },
        data(){
            return {
                values: []
            }
        },
        methods: {
            bindGameFields(){
                var self = this;
                return this.$hisport.datacontext.game_field.getAll({
                    page_index: 0, 
                    page_size: 999999,
                    column_filters: {
                        $and: [
                            {id_hgbox: {$isNull: false}},
                            {id_hgbox: {$ne: ''}}
                        ]
                    }
                }).then(function(game_fields){
                    self.values.forEach(function(x){
                        x.entities = game_fields.entries.filter(y=>y.id_hgbox==x.Sku);
                    })
                    self.values.sort(function(a,b){
                        if(a.entities.length>b.entities.length)
                            return -1;
                        return 1;
                    });
                })
            },
            onChange: function(event){
                this.$emit('input', event)
                // this.$emit('input', event.target.value)
            }
        }
   };
</script>